import BillingsPlanEntryTaxiDriverRecalculateRequest, {
  BillingsPlanEntryTaxiDriverRecalculateRequestBody,
} from "./billings-plan-entry-taxi-driver-recalculate.request";

const createBody = (
  request: BillingsPlanEntryTaxiDriverRecalculateRequest,
): BillingsPlanEntryTaxiDriverRecalculateRequestBody => {
  return {
    billingContributions: request.billingContributions,
    billingNodes: request.billingNodes,
  };
};

const billingsPlanEntryTaxiDriverRecalculateRequestFactory = {
  createBody,
};

export default billingsPlanEntryTaxiDriverRecalculateRequestFactory;
